export interface Breadcrumb {
  name: string
  path: string
}

/** Schema.org `BreadcrumbList` with absolute URLs, which search engines require: the paths resolve against `pageUrl`. */
export function breadcrumbList(breadcrumbs: Breadcrumb[], pageUrl: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((breadcrumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: breadcrumb.name,
      item: new URL(breadcrumb.path, pageUrl).href,
    })),
  }
}
